import React from "react";

// Steam sign-in is a top-level redirect (OpenID 2.0), not a popup like Google,
// so we expose a stable URL rather than a callback. Components that want to
// initiate Steam auth should `<a href={steamSignInUrl}>` or
// `window.location.assign(steamSignInUrl)`.
const DEFAULT_STEAM_SIGN_IN_URL =
  process.env.NODE_ENV === "production"
    ? "/edge/auth/steam"
    : "http://localhost:3010/auth/steam";

const DEFAULT_PLAYSAFE_SIGN_IN_URL =
  process.env.NODE_ENV === "production"
    ? "/edge/auth/login"
    : "http://localhost:3010/auth/login";

export const AuthStateContext = React.createContext({
  isAuthenticated: false,
  hasStoredToken: false,
  autoLoginInProgress: false,
  twoFactorPending: false,
  performLogout: false,
  sessionRestoreFailed: false,
  retrySessionRestore: () => {},
  googleResponse: () => {},
  onFailure: () => {},
  steamSignInUrl: DEFAULT_STEAM_SIGN_IN_URL,
  playsafeSignInUrl: DEFAULT_PLAYSAFE_SIGN_IN_URL,
  user: null,
  logout: () => {},
});

export const STEAM_SIGN_IN_URL = DEFAULT_STEAM_SIGN_IN_URL;
export const PLAYSAFE_SIGN_IN_URL = DEFAULT_PLAYSAFE_SIGN_IN_URL;

export function useAuthState() {
  return React.useContext(AuthStateContext);
}
